<kendo-dialog [title]="dialogTitle" (close)="closePopup(false)" [width]="width" [height]="height">
    <div *ngIf="dialogTitle == null || dialogTitle == ''" class="empty-close-block">
        <span class="close-icon" (click)="closePopup(false)">
            <fa-icon [icon]="iconPacks.FAXMARK"></fa-icon>
        </span>
    </div>
    <ng-content [ngClass]="{'mt-10': dialogTitle == null || dialogTitle == ''}"></ng-content>
</kendo-dialog>